module.exports = __webpack_public_path__ + "img/type2-bg1.4168c283.png";